<template>
    <div>
        <div class="btn-add" @click="isOpenForm = !isOpenForm">
            <span class="btn-add__text">ADD</span>
        </div>
        <transition name="open-add-form">
            <form action class="form-add" v-if="isOpenForm">
                <div class="form-block">
                    <div class="form__conteiner">
                        <div class="form__field">
                            <input
                                class="form__input form__input--project_name"
                                type="text"
                                name="data[project_name]"
                                v-model="data.project_name"
                            />
                            <span
                                class="form__field-lable"
                                :class="{ 'form__field-lable--active': data.project_name }"
                            >Project Name</span>
                        </div>
                        <div class="form__field">
                            <input
                                class="form__input"
                                type="text"
                                name="data[host]"
                                v-model="data.host"
                            />
                            <span
                                class="form__field-lable"
                                :class="{ 'form__field-lable--active': data.host }"
                            >Host</span>
                        </div>
                        <div class="form__field">
                            <input class="form__input" name="data[login]" v-model="data.login" />
                            <span
                                class="form__field-lable"
                                :class="{ 'form__field-lable--active': data.login }"
                            >Login</span>
                        </div>
                        <div class="form__field">
                            <input
                                class="form__input"
                                type="text"
                                name="data[password]"
                                v-model="data.password"
                            />
                            <span
                                class="form__field-lable"
                                :class="{ 'form__field-lable--active': data.password }"
                            >Password</span>
                        </div>
                        <div class="form__field">
                            <input
                                class="form__input"
                                type="text"
                                name="data[type]"
                                v-model="data.type"
                            />
                            <span
                                class="form__field-lable"
                                :class="{ 'form__field-lable--active': data.type }"
                            >Type</span>
                        </div>
                        <div class="form__field form__field--comment">
                            <textarea
                                class="form__input"
                                rows="5"
                                name="data[comment]"
                                v-model="data.comment"
                            />
                            <span
                                class="form__field-lable"
                                :class="{ 'form__field-lable--active': data.comment }"
                            >Comment</span>
                        </div>
                    </div>
                    <div class="form__btn">
                        <BtnOk @clickokay="popupOpen = true" />
                        <BtnCancel @clickcencel="isOpenForm = false;popupOpen = false;" />
                    </div>
                </div>
                <PopUp
                    :isOpen="popupOpen"
                    @popupclickokay="addElement"
                    @popupclickcencel="popupOpen = false"
                    text="Добавить элемент?"
                />
            </form>
        </transition>
    </div>
</template>

<script>
import BtnOk from "@/components/form/BtnOk.vue";
import BtnCancel from "@/components/form/BtnCancel.vue";
import PopUp from "@/components/PopUp.vue";
import qs from "qs";

export default {
    components: {
        BtnOk,
        BtnCancel,
        PopUp
    },

    data() {
        return {
            isOpenForm: false,
            data: {},
            popupOpen: false
        };
    },

    methods: {
        resetForm() {
            this.data = {};
        },
        addElement() {
            this.axios
                .post("/api/add", qs.stringify({ data: this.data }))
                .then(response => {
                    this.$emit("refresh", response.data);
                    this.resetForm();
                    this.popupOpen = false;
                    this.isOpenForm = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        pressKey(e) {
            this.open(e);
            this.save(e);
        },
        open(e) {
            if (e.ctrlKey && e.keyCode === 65) { 
                e.preventDefault();
                this.isOpenForm = !this.isOpenForm;
                setTimeout(function() {
                    let input = document.getElementsByClassName('form__input--project_name')[0];
                    if (input) {
                        input.focus();
                    }
                }, 500);
            }
        },
        save(e) {
            if (e.ctrlKey && e.keyCode === 83) { 
                e.preventDefault();
                if (Object.keys(this.data).length !== 0) {
                    this.addElement();
                }
            }
        }
    },

    created() {
        window.addEventListener("keydown", this.pressKey);
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.pressKey);
    },
};
</script>

<style lang="sass" scoped>
.btn-add
    position: fixed
    top: 0
    bottom: 0
    left: 0
    width: 50px
    display: flex
    cursor: pointer
    background-color: $grey-l
    opacity: 0.3
    +trans
    &:hover
        opacity: 1
.form-add
    position: fixed
    background-color: $grey-d
    +wpa
    top: 0
    left: 0
    display: flex
    z-index: 100
.form-block
    margin: auto
.form__conteiner
    margin: auto
.form__field--comment textarea
    background-color: $grey-l
.btn-add__text
    transform: rotate(-90deg)
    margin: auto
.btn
    background-color: $grey-l
.open-add-form-enter-active, .open-add-form-leave-active
    +trans(500ms)
.open-add-form-enter, .open-add-form-leave-to
    left: -100%
.form__field
    background-color: $grey-l
.form__conteiner
    padding: 0
</style>
